import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { environment as devEnvironment } from 'src/environments/environment.dev'
import { Environment } from 'src/environments/environment.model'
import { environment as prodEnvironment } from 'src/environments/environment.prod'
import { environment as localEnvironment } from 'src/environments/environment.local'
import runtime from 'src/assets/runtime/runtime.json'

const ENVIRONMENT_KEY = 'ENVIRONMENT'
export const LOCAL_ENVIRONMENT = 'LOCAL'
export const DEV_ENVIRONMENT = 'DEV'
export const PROD_ENVIRONMENT = 'PROD'

@Injectable({ providedIn: 'root' })
export class EnvironmentService {

  getCurrentEnvironment(): string {
    return localStorage.getItem(ENVIRONMENT_KEY);
  }

  load() {
    const defaultEnvironment =
      runtime.defaultEnvironment ?? PROD_ENVIRONMENT
    const env =
      localStorage.getItem(ENVIRONMENT_KEY) ?? defaultEnvironment

    if (env === PROD_ENVIRONMENT) {
      this.loadEnvironment(prodEnvironment)
    } else if (env === LOCAL_ENVIRONMENT) {
      this.loadEnvironment(localEnvironment)
    } else {
      this.loadEnvironment(devEnvironment)
    }
  }

  switchEnvironment(env: string) {
    localStorage.setItem(
      ENVIRONMENT_KEY,
      env
    )

    window.location.reload()
  }

  private loadEnvironment(env: Environment) {
    environment.apiBasePath = env.apiBasePath
    environment.chatBasePath = env.chatBasePath
    environment.chatWssPath = env.chatWssPath
    environment.oauthConfig = env.oauthConfig
    environment.production = env.production
    environment.configId = env.configId
  }
}
